








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class HeaderSection extends Vue {
    @Prop() header: string;
    @Prop() subHeader: string;
    @Prop({default: '#00897B'}) dividerColor: string;
    @Prop({default: '#000000'}) foreColor: string;
}
